/* jshint esversion: 6 */
import _ from "lodash";
import axios from "@/utils/request";
import { asyncRouterMap, constantRouterMap } from "@/configs/router.config";
import { arrayToTree, treeToArray } from "@/utils";
import router from "@/router";

function filterAsyncRouter(asyncRouterMap, authList, isAdmin) {
  const asyncRouterList = treeToArray(asyncRouterMap, [], "name", "pid", "children").map((r) => {
    if (r.children) delete r.children;
    return r;
  });
  if (!isAdmin) {
    const authAliaList = authList.map((auth) => auth.alias);
    const accessedRouters = asyncRouterList.filter((route, index) => authAliaList.includes(route.name) && route.path);
    return arrayToTree(
      accessedRouters.sort((a, b) => a.sort - b.sort),
      "name",
      "pid",
      "children"
    );
  } else {
    return arrayToTree(
      asyncRouterList.filter((r) => r.path).sort((a, b) => a.sort - b.sort),
      "name",
      "pid",
      "children"
    );
  }
}

function addParentAuth(asyncRouterMap, authList) {
  let flag = false;
  asyncRouterMap.forEach((route, index) => {
    const auth = authList.find((auth) => auth.alias === route.name);
    if (auth) {
      authList.push({
        alias: route.name,
        name: route.meta.title,
      });
      flag = true;
    } else if (route.children && route.children.length) {
      if (addParentAuth(route.children, authList)) {
        authList.push({
          alias: route.name,
          name: route.meta.title,
        });
        flag = true;
      }
    }
  });
  return flag;
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    permissions: [],
    // 所属单位列表
    companyList: [],
    // 当前用户 数据权限列表
    authUserList: [],
    // 当前用户 岗位列表
    authRoleList: [],
  },
  mutations: {
    SET_PER_DATA: (state, { key, value = [] }) => {
      state[key] = Object.freeze(value);
    },
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
      if (!routers || routers.length < 1) router.removeRoute("error"); // 同时删除菜单权限
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions;
    },
  },
  actions: {
    FETCH_DATA_AUTH_USER_LIST: ({ commit, state }, force = false) => {
      return new Promise((resolve, reject) => {
        if (!state.authUserList || !state.authUserList.length || force) {
          axios({
            url: "/manage/user/load-manage-user-list",
          }).then((response) => {
            if (response.code === 200) {
              commit("SET_PER_DATA", {
                key: "authUserList",
                value: response.data,
              });
              return resolve(response);
            } else {
              return reject(new Error(response));
            }
          });
        } else {
          return resolve();
        }
      });
    },
    FETCH_COMPANY_LIST: ({ commit, state }, force = false) => {
      return new Promise((resolve, reject) => {
        if (!state.companyList || !state.companyList.length || force) {
          axios({
            url: "/manage/user/load-company-list",
          }).then((response) => {
            if (response.code === 200) {
              commit("SET_PER_DATA", {
                key: "companyList",
                value: response.list,
              });
              return resolve(response);
            } else {
              return reject(new Error(response));
            }
          });
        } else {
          return resolve();
        }
      });
    },
    FETCH_AUTH_ROLE_LIST: ({ commit, state }, force = false) => {
      return new Promise((resolve, reject) => {
        if (!state.roleList || !state.roleList.length || force) {
          axios({
            url: "/manage/role/owenroles",
            method: "GET",
          }).then((response) => {
            if (response.code === 200) {
              commit("SET_PER_DATA", {
                key: "authRoleList",
                value: response.list,
              });
              return resolve(response.list);
            }
            return reject(new Error("加载数据失败"));
          });
        } else {
          return resolve();
        }
      });
    },
    GenerateRoutes({ commit, getters }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: "/manage/user/menu/nav",
          method: "get",
        })
          .then((response) => {
            if (response.code === 200) {
              const authList = response.menuList;
              if (getters.userInfo.id != 1) {
                addParentAuth(asyncRouterMap, authList);
              }
              const addRouters = [
                {
                  path: "/",
                  name: "main",
                  component: () => import("@/views/pages/index"),
                  meta: { title: "首页" },
                  redirect: "/dashboard",
                  children: filterAsyncRouter(_.cloneDeep(asyncRouterMap), authList, getters.userInfo.id === '1'),
                },
              ];
              addRouters.push({
                path: "/:catchAll(.*)",
                name: "error",
                redirect: "/404",
                hidden: true,
              });
              commit("SET_ROUTERS", addRouters);
              commit("SET_PERMISSIONS", response.permissions);
              resolve(addRouters);
            } else {
              commit("SET_ROUTERS", []);
              commit("SET_PERMISSIONS", []);
              reject(new Error(response.msg));
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default permission;
